import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import { useOutletContext } from "react-router-dom";
import { customQuereiesDrawerElements } from "./data";
import PlanningSaleQuery from "./DashboardComponents/PlanningSaleQuery/PlanningSaleQuery";
import AllChannelDispatch from "./DashboardComponents/AllChannelDispatch/AllChannelDispatch";
import EboSohDaily from "./DashboardComponents/EboSohDaily/EboSohDaily";
import InventorySnapshot from "./DashboardComponents/InventorySnapShot/InventorySnapShot";
import CustomerCohortCount from "./DashboardComponents/CustomerCohortCount/CustomerCohortCount";
import CustomerCohortCountOfBill from "./DashboardComponents/CustomerCohortCountOfBill/CustomerCohortCountOfBill";
import CustomerCohortRealisedValue from "./DashboardComponents/CustomerCohortRealisedValue/CustomerCohortRealisedValue";
import Git from "./DashboardComponents/Git/git";
import Tir from "./DashboardComponents/TIR/Tir";
import EcomSale from "./DashboardComponents/EcomSale/EcomSale";
import EboSale from "./DashboardComponents/EboSale/EboSale";
import ShopifySOH from "./DashboardComponents/ShopifySOH/ShopifySoh";
import HistoricalSOH from "./DashboardComponents/HistoricalSOH/HistoricalSOH";
import ItemMaster from "./DashboardComponents/ItemMaster/ItemMaster";
import GoodsReceiveRegister from "./DashboardComponents/StoreRegister/GoodsReceiveRegister/GoodsReceiveRegister";
import GoodsReturnRegister from "./DashboardComponents/StoreRegister/GoodsReturnRegister/GoodsReturnRegister";
import EboRtv from "./DashboardComponents/Rtv/EboRtv";
import MboRtv from "./DashboardComponents/Rtv/MboRtv";
import StyleSOHContribution from "./DashboardComponents/StylewiseSOHContri/StylewiseSOHContri";
import AllChannelSales from "./DashboardComponents/AllChannelSales/AllChannelSales";
import ProductwiseSession from "./DashboardComponents/ProductwiseSession/ProductwiseSession";
import TotalInTotalOut from "./DashboardComponents/TotalInTotalOut/TotalInTotalOut";
import UcSaleReport from "./DashboardComponents/Ecomm/UcSaleReport/UcSaleReport";
import GinesysSaleReport from "./DashboardComponents/Ecomm/GinesysSaleReport/GinesysSaleReport";
import Insurance from "./DashboardComponents/Insurance/Insurance";

const CustomQueriesDashboard = () => {
	const [pathName, service] = useOutletContext();

	const tabComponents = {
		[customQuereiesDrawerElements.planning_sale_query.key]: {
			...customQuereiesDrawerElements.planning_sale_query,
			component: <PlanningSaleQuery activeService={service} />,
		},
		[customQuereiesDrawerElements.all_channel_dispatch.key]: {
			...customQuereiesDrawerElements.all_channel_dispatch,
			component: <AllChannelDispatch activeService={service} />,
		},
		[customQuereiesDrawerElements.soh.types.ebo_soh_daily.key]: {
			...customQuereiesDrawerElements.soh.types.ebo_soh_daily,
			component: <EboSohDaily activeService={service} />,
		},
		[customQuereiesDrawerElements.inventory_snapshot.key]: {
			...customQuereiesDrawerElements.inventory_snapshot,
			component: <InventorySnapshot activeService={service} />,
		},
		[customQuereiesDrawerElements.git.key]: {
			...customQuereiesDrawerElements.git,
			component: <Git activeService={service} />,
		},
		[customQuereiesDrawerElements.tir.key]: {
			...customQuereiesDrawerElements.tir,
			component: <Tir activeService={service} />,
		},

		[customQuereiesDrawerElements.ecom_sales.key]: {
			...customQuereiesDrawerElements.ecom_sales,
			component: <EcomSale activeService={service} />,
		},
		[customQuereiesDrawerElements.ebo_sales.key]: {
			...customQuereiesDrawerElements.ebo_sales,
			component: <EboSale activeService={service} />,
		},
		[customQuereiesDrawerElements.ecomm.types.uc_sale_report.key]: {
			...customQuereiesDrawerElements.ecomm.types.uc_sale_report,
			component: <UcSaleReport activeService={service} />,
		},
		[customQuereiesDrawerElements.ecomm.types.ginesys_sale_report.key]: {
			...customQuereiesDrawerElements.ecomm.types.ginesys_sale_report,
			component: <GinesysSaleReport activeService={service} />,
		},
		[customQuereiesDrawerElements.insurance.key]: {
			...customQuereiesDrawerElements.insurance,
			component: <Insurance activeService={service} />,
		},
		[customQuereiesDrawerElements.soh.types.shopify_soh.key]: {
			...customQuereiesDrawerElements.shopify_soh,
			component: <ShopifySOH activeService={service} />,
		},
		[customQuereiesDrawerElements.store_register.types.goods_receive_register.key]: {
			...customQuereiesDrawerElements.store_register,
			component: <GoodsReceiveRegister activeService={service} />,
		},
		[customQuereiesDrawerElements.store_register.types.goods_return_register.key]: {
			...customQuereiesDrawerElements.store_register,
			component: <GoodsReturnRegister activeService={service} />,
		},
		[customQuereiesDrawerElements.soh.types.historical_soh.key]: {
			...customQuereiesDrawerElements.historical_soh,
			component: <HistoricalSOH activeService={service} />,
		},
		[customQuereiesDrawerElements.rtv.types.ebo_rtv.key]: {
			...customQuereiesDrawerElements.ebo_rtv,
			component: <EboRtv activeService={service} />,
		},
		[customQuereiesDrawerElements.rtv.types.mbo_rtv.key]: {
			...customQuereiesDrawerElements.mbo_rtv,
			component: <MboRtv activeService={service} />,
		},

		[customQuereiesDrawerElements.customer_cohort.types.customer_count.key]: {
			...customQuereiesDrawerElements.customer_cohort.types.customer_count,
			component: <CustomerCohortCount activeService={service} />,
		},
		[customQuereiesDrawerElements.customer_cohort.types.count_of_bill.key]: {
			...customQuereiesDrawerElements.customer_cohort.types.count_of_bill,
			component: <CustomerCohortCountOfBill activeService={service} />,
		},
		[customQuereiesDrawerElements.customer_cohort.types.realised_value.key]: {
			...customQuereiesDrawerElements.customer_cohort.types.realised_value,
			component: <CustomerCohortRealisedValue activeService={service} />,
		},
		[customQuereiesDrawerElements.item_master.key]: {
			...customQuereiesDrawerElements.item_master,
			component: <ItemMaster activeService={service} />,
		},
		[customQuereiesDrawerElements.style_soh_contribution.key]: {
			...customQuereiesDrawerElements.style_soh_contribution,
			component: <StyleSOHContribution activeService={service} />,
		},
		[customQuereiesDrawerElements.all_channel_sales.key]: {
			...customQuereiesDrawerElements.all_channel_sales,
			component: <AllChannelSales activeService={service} />,
		},
		[customQuereiesDrawerElements.productwise_session.key]: {
			...customQuereiesDrawerElements.productwise_session,
			component: <ProductwiseSession activeService={service} />,
		},
		[customQuereiesDrawerElements.total_in_total_out.key]: {
			...customQuereiesDrawerElements.total_in_total_out,
			component: <TotalInTotalOut activeService={service} />,
		},
	};

	const activeTab = tabComponents?.[pathName];

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				flexDirection: "column",
				minWidth: 0,
			}}>
			{/* Offsets the fixed AppBar so the header is not hidden behind it */}
			<Toolbar disableGutters />

			<Box
				sx={{
					flexShrink: 0,
					px: { xs: 2, md: 3 },
					py: 1.5,
					borderBottom: "1px solid",
					borderColor: "divider",
				}}>
				<Typography variant="h6" sx={{ fontWeight: 600 }} noWrap>
					{service?.name}
				</Typography>
			</Box>

			<Box
				sx={{
					flex: 1,
					minHeight: 0,
					minWidth: 0,
					overflowY: "auto",
					overflowX: "hidden",
					px: { xs: 2, md: 3 },
					py: 2.5,
				}}>
				{activeTab?.component}
			</Box>
		</Box>
	);
};

export default CustomQueriesDashboard;
